export const FEEDBACK_SURVEY_REQUEST_EVENT = "shuttlerock:feedback-survey-request";

export type FeedbackSurveyName = "concept_quality" | "nps";

export const FEEDBACK_SURVEY_CONTEXT = {
  ConceptApproval: "concept_approval",
} as const;

export type FeedbackSurveyContext =
  (typeof FEEDBACK_SURVEY_CONTEXT)[keyof typeof FEEDBACK_SURVEY_CONTEXT];

export type FeedbackSurveyRequest = {
  survey: FeedbackSurveyName;
  params?: Record<string, string | number | boolean | undefined | null>;
};

export const requestFeedbackSurvey = (request: FeedbackSurveyRequest) => {
  window.dispatchEvent(
    new CustomEvent<FeedbackSurveyRequest>(FEEDBACK_SURVEY_REQUEST_EVENT, {
      detail: request,
    }),
  );
};
